import {styled} from "@mui/material/styles";
import {Typography} from "@mui/material";

const StyledSubheader = styled(Typography)(({theme}) => ({
  fontSize: "1.5rem",
  marginBottom: theme.spacing(4),
  color: theme.palette.text.secondary,
}));

export default StyledSubheader;
